module.exports = __webpack_public_path__ + "img/zosi.856cfd2b.svg";